<template>
  <div class="artikl-pregled forma-erp">

    <!-- Zaglavlje: slika, naziv, sifra/grupa/mjera i oznake. Brisanje je
         kanta lijevo od uredjivanja, odmaknuta da se ne klikne slucajno. -->
    <div class="traka-artikl">
      <img v-if="zadanaSlikaSrc" :src="zadanaSlikaSrc" class="slika-velika" alt="" @click="otvoriSliku(zadanaSlikaSrc)">
      <v-icon v-if="!zadanaSlikaSrc" class="slika-prazna" color="white">mdi-image-outline</v-icon>
      <div class="opis">
        <div class="naslov">{{ item.itemName }}</div>
        <div class="pod">
          <span class="znak" v-if="item.itemID">{{ item.itemID }}</span>
          <span class="znak" v-if="item.GroupName || item.itemGroup">{{ item.GroupName ? item.GroupName : item.itemGroup }}</span>
          <span class="znak" v-if="item.itemUnit">{{ item.itemUnit }}</span>
          <span class="znak usluga" v-if="item.itemService">{{ lang.ItemIsService }}</span>
          <span class="znak" v-if="item.itemWeb">{{ lang.ItemIsWeb }}</span>
          <span class="znak neaktivan" v-if="item.itemNotActiv">{{ lang.ItemIsNotActiv }}</span>
          <span class="znak neaktivan" v-if="item.itemHideForever">{{ lang.ItemIsHidden }}</span>
        </div>
      </div>
      <v-spacer></v-spacer>
      <v-btn
        v-if="razinaPristupa === 1"
        icon
        dark
        class="mr-6"
        :title="langC.Delete"
        @click="itemDelete"
      >
        <v-icon>mdi-trash-can-outline</v-icon>
      </v-btn>
      <v-btn v-if="razinaPristupa <= 3" small class="white primary--text mr-2" @click="itemEdit">
        {{ langC.Edit }}
      </v-btn>
      <v-btn small class="green white--text" @click="itemlist">
        {{ langC.Back }}
      </v-btn>
    </div>

    <!-- Ono zbog cega se artikl najcesce otvara. -->
    <div class="brojke">
      <div class="stavka">
        <span>{{ lang.ItemPrice }}</span>
        <b class="glavno">{{ novac(item.itemPrice) }} {{ currency }}</b>
      </div>
      <div class="crta"></div>
      <div class="stavka">
        <span>{{ lang.ItemPriceWithVAT }}</span>
        <b>{{ novac(item.itemPriceWithVAT) }} {{ currency }}</b>
      </div>
      <div class="crta"></div>
      <div class="stavka">
        <span>{{ lang.ItemSuppPrice }}</span>
        <b>{{ novac(item.itemSuppPrice) }} {{ currency }}</b>
      </div>
      <div class="crta"></div>
      <div class="stavka">
        <span>{{ lang.ItemMargin }}</span>
        <b>{{ postotak(item.itemMargin) }}</b>
      </div>
      <div class="crta"></div>
      <div class="stavka">
        <span>{{ lang.ItemVAT1Percentage }}</span>
        <b>{{ postotak(item.itemVAT1Percentage) }}</b>
      </div>
      <v-spacer></v-spacer>
      <v-checkbox
        v-model="svaPolja"
        :label="lang.ItemShowAllFields"
        hide-details
        dense
        class="mt-0 pt-0"
      ></v-checkbox>
    </div>

    <v-row no-gutters>
      <!-- ---------- lijevi stupac: opisno ---------- -->
      <v-col cols="12" md="6" class="pr-md-2">

        <v-card outlined class="mb-3">
          <v-card-title class="naslov-kartice">{{ lang.BasicData }}</v-card-title>
          <v-card-text class="tijelo">
            <div class="polja">
              <template v-for="polje in osnovniPodaci">
                <div class="naziv" :key="polje.kljuc + '-n'" v-if="polje.vrijednost || svaPolja">{{ polje.naziv }}</div>
                <div class="vrijednost" :key="polje.kljuc + '-v'" v-if="polje.vrijednost || svaPolja">
                  <span v-if="polje.vrijednost">{{ polje.vrijednost }}</span>
                  <span v-if="!polje.vrijednost" class="prazno">—</span>
                  <span v-if="polje.dodatak" class="uz-vrijednost">({{ polje.dodatak }})</span>
                </div>
              </template>
              <div class="naziv">{{ lang.ItemFlags }}</div>
              <div class="vrijednost oznake">{{ oznake }}</div>
            </div>
          </v-card-text>
        </v-card>

        <v-card outlined class="mb-3">
          <v-card-title class="naslov-kartice">
            {{ lang.ItemPictures }}
            <span class="dodatak" v-if="slikeArtikla.length">{{ lang.ItemDefaultPictureHint }}</span>
          </v-card-title>
          <v-card-text class="tijelo">
            <div class="slicice" v-if="slikeArtikla.length">
              <div class="slicica-okvir" v-for="slika in slikeArtikla" :key="slika.broj">
                <img
                  v-if="prikaz[slika.broj]"
                  :src="prikaz[slika.broj]"
                  class="slicica"
                  alt=""
                  @click="otvoriSliku(prikaz[slika.broj])"
                >
                <v-icon v-if="!prikaz[slika.broj]" class="slicica-nema" color="grey lighten-1">mdi-image-off</v-icon>
                <div class="zvjezdica" v-if="slika.zadana">★</div>
              </div>
            </div>
            <span v-if="!slikeArtikla.length" class="prazno sitno-prazno">{{ lang.ItemNoPictures }}</span>
          </v-card-text>
        </v-card>

        <v-card outlined class="mb-3">
          <v-card-title class="naslov-kartice sklopiva" @click="skladisteOtvoreno = !skladisteOtvoreno">
            {{ lang.ItemWarehouseDim }}
            <span class="dodatak" v-if="!imaSkladiste">{{ lang.ItemEmptyCard }}</span>
            <v-spacer></v-spacer>
            <v-icon small>{{ (skladisteOtvoreno || svaPolja) ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
          </v-card-title>
          <v-card-text class="tijelo" v-if="skladisteOtvoreno || svaPolja">
            <div class="polja">
              <template v-for="polje in skladisteDimenzije">
                <div class="naziv" :key="polje.kljuc + '-n'">{{ polje.naziv }}</div>
                <div class="vrijednost" :key="polje.kljuc + '-v'">
                  <span v-if="polje.vrijednost">{{ polje.vrijednost }}</span>
                  <span v-if="!polje.vrijednost" class="prazno">—</span>
                </div>
              </template>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- ---------- desni stupac: novcano ---------- -->
      <v-col cols="12" md="6" class="pl-md-2">

        <v-card outlined class="mb-3">
          <v-card-title class="naslov-kartice">
            {{ lang.Price }}
            <span class="dodatak">{{ lang.ItemHomeCurrencyShort }}</span>
          </v-card-title>
          <v-card-text class="tijelo">
            <!-- Cijena kao obracun odozgo prema dolje, da se vidi kako je nastala. -->
            <table class="obracun">
              <tr v-if="item.ItemSuppCode || svaPolja">
                <td>{{ lang.ItemSuppCode }}</td>
                <td class="tekstualno">
                  <span v-if="item.ItemSuppCode">{{ item.ItemSuppCode }}</span>
                  <span v-if="!item.ItemSuppCode" class="prazno">—</span>
                </td>
              </tr>
              <tr v-if="pNum(item.itemSuppBasePrice) !== 0 || svaPolja">
                <td>{{ lang.ItemSuppBasePrice }}</td>
                <td>{{ novac(item.itemSuppBasePrice) }}</td>
              </tr>
              <tr v-if="pNum(item.itemSuppDiscount) !== 0 || svaPolja">
                <td>{{ lang.ItemSuppDiscount }}</td>
                <td>{{ postotak(item.itemSuppDiscount) }}</td>
              </tr>
              <tr v-if="pNum(item.itemSuppPrice) !== 0 || svaPolja">
                <td>{{ lang.ItemSuppPriceWithDiscount }}</td>
                <td>{{ novac(item.itemSuppPrice) }}</td>
              </tr>
              <tr v-if="pNum(item.itemMargin) !== 0 || svaPolja">
                <td>{{ lang.ItemMargin }}</td>
                <td>{{ postotak(item.itemMargin) }}</td>
              </tr>
              <tr class="zbroj">
                <td>{{ lang.ItemPrice }}</td>
                <td>{{ novac(item.itemPrice) }}</td>
              </tr>
              <tr>
                <td>{{ lang.ItemVAT1Percentage }}</td>
                <td>{{ postotak(item.itemVAT1Percentage) }}</td>
              </tr>
              <tr v-if="pNum(item.itemVAT1Amount) !== 0 || svaPolja">
                <td>{{ lang.ItemVAT1Amount }}</td>
                <td>{{ novac(item.itemVAT1Amount) }}</td>
              </tr>
              <tr v-if="pNum(item.itemDirectDuty1) !== 0 || svaPolja">
                <td>{{ lang.ItemDirectDuty1 }}</td>
                <td>{{ novac(item.itemDirectDuty1) }}</td>
              </tr>
              <tr v-if="pNum(item.itemDirectDuty2) !== 0 || svaPolja">
                <td>{{ lang.ItemDirectDuty2 }}</td>
                <td>{{ novac(item.itemDirectDuty2) }}</td>
              </tr>
              <tr class="zbroj">
                <td>{{ lang.ItemPriceWithVAT }}</td>
                <td>{{ novac(item.itemPriceWithVAT) }}</td>
              </tr>
              <tr v-if="pNum(item.itemMaxDiscount) !== 0 || svaPolja">
                <td>{{ lang.ItemMaxDiscount }}</td>
                <td>{{ postotak(item.itemMaxDiscount) }}</td>
              </tr>
              <!-- Sidrena (dodatna) cijena - NN 101/2026. Pokazuje se uvijek, i
                   kad nije utvrdjena: prazan redak je podatak, jer takav artikl
                   ne smije u objavljeni cjenik. -->
              <tr class="sidrena-redak">
                <td>Sidrena cijena{{ item.sidrenaCijenaDatum ? ' (' + datumHR(item.sidrenaCijenaDatum) + ')' : '' }}</td>
                <td v-if="imaSidrenu">{{ novac(item.sidrenaCijena) }}</td>
                <td v-else class="nema-sidrene">nije utvrđena</td>
              </tr>
            </table>
          </v-card-text>
        </v-card>

        <v-card outlined class="mb-3">
          <v-card-title class="naslov-kartice sklopiva" @click="popustiOtvoreno = !popustiOtvoreno">
            {{ lang.ItemQtyDiscounts }}
            <span class="dodatak" v-if="!imaPopuste">{{ lang.ItemEmptyCard }}</span>
            <v-spacer></v-spacer>
            <v-icon small>{{ (popustiOtvoreno || svaPolja) ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
          </v-card-title>
          <v-card-text class="tijelo" v-if="popustiOtvoreno || svaPolja">
            <div class="polja">
              <template v-for="red in kolicinskiPopusti">
                <div class="naziv" :key="red.broj + '-n'">{{ lang.ItemQty }} {{ red.broj }}</div>
                <div class="vrijednost" :key="red.broj + '-v'">
                  <span v-if="red.kolicina">{{ red.kolicina }}</span>
                  <span v-if="!red.kolicina" class="prazno">—</span>
                  /
                  <span v-if="red.popust">{{ red.popust }}</span>
                  <span v-if="!red.popust" class="prazno">—</span>
                </div>
              </template>
            </div>
          </v-card-text>
        </v-card>

        <v-card outlined class="mb-3">
          <v-card-title class="naslov-kartice sklopiva" @click="izvozOtvoreno = !izvozOtvoreno">
            {{ lang.PriceExp }}
            <span class="dodatak" v-if="!imaIzvoz">{{ lang.ItemEmptyCard }}</span>
            <v-spacer></v-spacer>
            <v-icon small>{{ (izvozOtvoreno || svaPolja) ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
          </v-card-title>
          <v-card-text class="tijelo" v-if="izvozOtvoreno || svaPolja">
            <table class="obracun">
              <tr v-for="red in izvoznaCijena" :key="red.kljuc">
                <td>{{ red.naziv }}</td>
                <td>
                  <span v-if="red.vrijednost">{{ red.vrijednost }}</span>
                  <span v-if="!red.vrijednost" class="prazno">—</span>
                </td>
              </tr>
            </table>
          </v-card-text>
        </v-card>

        <v-card outlined class="mb-3">
          <v-card-title class="naslov-kartice">{{ lang.ItemRecord }}</v-card-title>
          <v-card-text class="tijelo">
            <div class="polja">
              <div class="naziv">{{ lang.ItemLastUpdateBy }}</div>
              <div class="vrijednost">
                <span v-if="item.LastUpdateBy">{{ item.LastUpdateBy }}</span>
                <span v-if="!item.LastUpdateBy" class="prazno">—</span>
              </div>
              <div class="naziv">{{ lang.ItemLastUpdate }}</div>
              <div class="vrijednost">
                <span v-if="item.LastUpdate">{{ datum(item.LastUpdate) }}</span>
                <span v-if="!item.LastUpdate" class="prazno">—</span>
              </div>
              <div class="naziv">{{ lang.ItemDbId }}</div>
              <div class="vrijednost">{{ item.id }}</div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="dijalogSlika" max-width="600px">
      <v-card>
        <v-card-text class="text-center pt-4">
          <img :src="slikaVelika" style="max-width:100%;max-height:70vh" alt="">
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="dijalogSlika = false">{{ langC.Close }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import langEn from './itemDescEn'
import { dohvatiSliku } from './slikaArtikla'
import langHr from './itemDescHR'
import commEn from '@/language/commonEN'
import commHr from '@/language/commonHR'
import ItemService from '@/services/ItemService'
import moneyFormat from '@/snippets/moneyFormat'
import dayjs from 'dayjs'
import { domacaValuta } from '@/snippets/domacaValuta'

export default {
  name: 'itemview',
  data () {
    return {
      prikaz: {},
      lang: {},
      langC: {},
      menu: false,
      modal: false,
      msg: '',
      valid: true,
      samoZaProbu: 0,
      item: {},
      error: null,
      localError: false,
      privitems: [
        { text: 'EUR', value: 'EUR' },
        { text: 'Kn', value: 'Kn' },
        { text: 'USD', value: 'USD' },
        { text: 'GBP', value: 'GBP' }
      ],
      privGroups: [],
      currency: '',
      svaPolja: false,
      skladisteOtvoreno: false,
      popustiOtvoreno: false,
      izvozOtvoreno: false,
      dijalogSlika: false,
      slikaVelika: ''
    }
  },
  async mounted () {
    if (this.$store.state.language === 'EN') {
      this.lang = langEn
      this.langC = commEn
    }
    if (this.$store.state.language === 'HR') {
      this.lang = langHr
      this.langC = commHr
    }
    if (this.$store.state.itemid) {
      try {
        const dbItem = await ItemService.show(this.$store.state.itemid)
        this.item = dbItem.data.item
        this.currency = domacaValuta(this.$store.state.businessYear)

      } catch (error) {
        // eslint-disable-next-line
        console.log('error read from datebase')
      }
    }
  },
  methods: {
    pNum (vrijednost) {
      return parseFloat(vrijednost) || 0
    },
    datumHR (d) {
      return d ? dayjs(d).format('DD.MM.YYYY') : ''
    },
    // Nazivi u sifrarniku nose zvjezdicu za obavezno polje ("Sifra *"); u
    // pregledu se nema sto unijeti, pa zvjezdica samo smeta.
    bezZvjezdice (naziv) {
      return String(naziv || '').replace(/\s*\*\s*$/, '')
    },
    tekst (vrijednost) {
      return vrijednost === null || vrijednost === undefined ? '' : String(vrijednost).trim()
    },
    // Nula na ovim poljima znaci "nije upisano", pa se prikazuje kao prazno.
    broj (vrijednost) {
      const n = this.pNum(vrijednost)
      return n === 0 ? '' : String(vrijednost).trim()
    },
    novac (vrijednost) {
      return moneyFormat(this.pNum(vrijednost))
    },
    novacIliPrazno (vrijednost) {
      return this.pNum(vrijednost) === 0 ? '' : this.novac(vrijednost)
    },
    postotak (vrijednost) {
      return moneyFormat(this.pNum(vrijednost)) + ' %'
    },
    postotakIliPrazno (vrijednost) {
      return this.pNum(vrijednost) === 0 ? '' : this.postotak(vrijednost)
    },
    datum (vrijednost) {
      return vrijednost ? dayjs(vrijednost).format('DD.MM.YYYY') : ''
    },
    otvoriSliku (put) {
      if (!put) { return }
      this.slikaVelika = put
      this.dijalogSlika = true
    },
    async itemlist () {
      try {
        this.$store.dispatch('seteditItem', 0)
        await this.$router.push({
          name: 'item'
        })
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    },
    async itemDelete () {
      try {
        await this.$router.push({
          name: 'itemdelete'
        })
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    },
    async itemEdit () {
      try {
        this.$store.dispatch('seteditItem', 1)
        await this.$router.push({
          name: 'itemcreate'
        })
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    }
  },
  watch: {
    // Uploadana slika stoji u folderu firme i trazi prijavu, pa se dohvaca
    // s tokenom; javni link ide izravno.
    slikeArtikla: {
      immediate: true,
      async handler (popis) {
        const novi = {}
        for (const slika of popis) {
          novi[slika.broj] = await dohvatiSliku(slika.put, this.$store.state.companyid)
        }
        this.prikaz = novi
      }
    }
  },
  computed: {
    // Kad sesija istekne, "user" u storeu je null - prikaz to ne smije srusiti.
    // Razina iz baze stize kao tekst ("1.00"), pa mora u broj.
    razinaPristupa () {
      const u = this.$store.state.user
      return u && u.AccessLevel !== undefined ? (parseFloat(u.AccessLevel) || 9) : 9
    },

    // NULL znaci "nije utvrdjena", a 0,00 je stvarna cijena - zato se ne smije
    // provjeravati istinitost broja.
    imaSidrenu () {
      const v = this.item.sidrenaCijena
      return v !== null && v !== undefined && v !== ''
    },

    // Kartica se otvara sama kad ima sto pokazati; inace stoji sklopljena.
    imaSkladiste () {
      return this.skladisteDimenzije.some(polje => polje.vrijednost)
    },
    imaPopuste () {
      return this.kolicinskiPopusti.some(red => red.kolicina || red.popust)
    },
    imaIzvoz () {
      // Tecaj je popunjen na pola sifrarnika i sam po sebi ne znaci da artikl
      // ima izvozne cijene, pa se ne broji.
      return this.izvoznaCijena.some(red => red.kljuc !== 'ItemExRate' && red.vrijednost)
    },

    osnovniPodaci () {
      return [
        { kljuc: 'itemID', naziv: this.bezZvjezdice(this.lang.ItemID), vrijednost: this.tekst(this.item.itemID) },
        { kljuc: 'itemName', naziv: this.bezZvjezdice(this.lang.ItemName), vrijednost: this.tekst(this.item.itemName) },
        {
          kljuc: 'itemGroup',
          naziv: this.lang.ItemGroup,
          vrijednost: this.tekst(this.item.GroupName ? this.item.GroupName : this.item.itemGroup),
          // sifra grupe ide uz naziv, u zagradi, da ne trosi vlastiti red
          dodatak: this.item.GroupName ? this.tekst(this.item.itemGroup) : ''
        },
        { kljuc: 'itemUnit', naziv: this.lang.ItemUnit, vrijednost: this.tekst(this.item.itemUnit) },
        { kljuc: 'itemDescription', naziv: this.lang.ItemDescription, vrijednost: this.tekst(this.item.itemDescription) },
        { kljuc: 'ItemNameShort', naziv: this.lang.ItemNameShort, vrijednost: this.tekst(this.item.ItemNameShort) },
        { kljuc: 'ItemCode', naziv: this.lang.ItemCode, vrijednost: this.tekst(this.item.ItemCode) },
        { kljuc: 'ItemEANCode', naziv: this.lang.ItemEANCode, vrijednost: this.tekst(this.item.ItemEANCode) },
        { kljuc: 'ItemBelongsToId', naziv: this.lang.ItemBelongsToId, vrijednost: this.broj(this.item.ItemBelongsToId) }
      ]
    },

    skladisteDimenzije () {
      return [
        { kljuc: 'ItemWarehouse', naziv: this.lang.ItemWarehouse, vrijednost: this.tekst(this.item.ItemWarehouse) },
        { kljuc: 'ItemWarehouseRow', naziv: this.lang.ItemWarehouseRow, vrijednost: this.tekst(this.item.ItemWarehouseRow) },
        { kljuc: 'ItemWarehouseShelf', naziv: this.lang.ItemWarehouseShelf, vrijednost: this.tekst(this.item.ItemWarehouseShelf) },
        { kljuc: 'ItemWahrehouseFloor', naziv: this.lang.ItemWahrehouseFloor, vrijednost: this.tekst(this.item.ItemWahrehouseFloor) },
        { kljuc: 'ItemSize', naziv: this.lang.ItemSize, vrijednost: this.broj(this.item.ItemSize) },
        { kljuc: 'ItemWeight', naziv: this.lang.ItemWeight, vrijednost: this.broj(this.item.ItemWeight) },
        { kljuc: 'ItemDimLenght', naziv: this.lang.ItemDimLenght, vrijednost: this.broj(this.item.ItemDimLenght) },
        { kljuc: 'ItemDimHeight', naziv: this.lang.ItemDimHeight, vrijednost: this.broj(this.item.ItemDimHeight) },
        { kljuc: 'ItemDimDepth', naziv: this.lang.ItemDimDepth, vrijednost: this.broj(this.item.ItemDimDepth) }
      ]
    },

    kolicinskiPopusti () {
      return [1, 2, 3].map(broj => ({
        broj,
        kolicina: this.broj(this.item['itemDiscountAmount' + broj]),
        popust: this.pNum(this.item['itemDiscountPercentage' + broj]) !== 0
          ? this.postotak(this.item['itemDiscountPercentage' + broj]) : ''
      }))
    },

    izvoznaCijena () {
      return [
        { kljuc: 'ItemExRate', naziv: this.lang.ItemExRate, vrijednost: this.broj(this.item.ItemExRate) },
        { kljuc: 'itemForePrice', naziv: this.lang.ItemForePrice, vrijednost: this.novacIliPrazno(this.item.itemForePrice) },
        { kljuc: 'ItemForeVAT1Percentage', naziv: this.lang.ItemForeVAT1Percentage, vrijednost: this.postotakIliPrazno(this.item.ItemForeVAT1Percentage) },
        { kljuc: 'itemForeVAT1Amount', naziv: this.lang.ItemForeVAT1Amount, vrijednost: this.novacIliPrazno(this.item.itemForeVAT1Amount) },
        { kljuc: 'itemForeDirectDuty1', naziv: this.lang.ItemForeDirectDuty1, vrijednost: this.novacIliPrazno(this.item.itemForeDirectDuty1) },
        { kljuc: 'itemForeDirectDuty2', naziv: this.lang.ItemForeDirectDuty2, vrijednost: this.novacIliPrazno(this.item.itemForeDirectDuty2) },
        { kljuc: 'itemForePriceWithVAT', naziv: this.lang.ItemForePriceWithVAT, vrijednost: this.novacIliPrazno(this.item.itemForePriceWithVAT) }
      ]
    },

    oznake () {
      const popis = []
      popis.push(this.item.itemService ? this.lang.ItemIsService : '')
      popis.push(this.item.itemWeb ? this.lang.ItemIsWeb : '')
      popis.push(this.item.itemNotActiv ? this.lang.ItemIsNotActiv : this.lang.ItemIsActiv)
      if (this.item.itemHideForever) { popis.push(this.lang.ItemIsHidden) }
      return popis.filter(o => o).join(' · ')
    },

    zadanaSlikaSrc () {
      const zadana = this.slikeArtikla.find(slika => slika.zadana)
      const prva = this.slikeArtikla.length ? this.slikeArtikla[0] : null
      const odabrana = zadana || prva
      return odabrana ? this.prikaz[odabrana.broj] : ''
    },

    // Samo popunjene slike, sa zastavicom koja je zadana. Iz baze zadana
    // zna doci kao tekst, pa se pretvara u broj.
    slikeArtikla () {
      const zadana = parseInt(this.item.ItemDefaultPicture, 10)
      const popis = []
      for (let n = 1; n <= 7; n++) {
        const put = this.item['ItemPicture' + n]
        if (put && String(put).trim().length > 0) {
          popis.push({ broj: n, put: String(put).trim(), zadana: zadana === n })
        }
      }
      return popis
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.artikl-pregled { padding: 8px 12px; }

/* Sidrena cijena nije dio obracuna iznad nje, nego podatak o proslosti. */
.artikl-pregled .sidrena-redak td {
  border-top: 1px dashed #c8d3de;
  padding-top: 6px;
}
.artikl-pregled .nema-sidrene { color: #c62828; }

/* zaglavlje */
.artikl-pregled .traka-artikl {
  display: flex;
  align-items: center;
  gap: 14px;
  background: #1976d2;
  color: #fff;
  border-radius: 4px;
  padding: 10px 14px;
  margin-bottom: 12px;
}
.artikl-pregled .slika-velika {
  width: 56px;
  height: 56px;
  border-radius: 4px;
  object-fit: cover;
  border: 2px solid rgba(255, 255, 255, 0.5);
  background: #fff;
  flex: none;
  cursor: zoom-in;
}
.artikl-pregled .slika-prazna {
  font-size: 40px;
  opacity: 0.6;
}
.artikl-pregled .traka-artikl .naslov {
  font-size: 20px;
  font-weight: 700;
  line-height: 1.2;
}
.artikl-pregled .traka-artikl .pod {
  margin-top: 3px;
}
.artikl-pregled .znak {
  display: inline-block;
  font-size: 12px;
  font-weight: 500;
  background: rgba(255, 255, 255, 0.22);
  border-radius: 10px;
  padding: 1px 9px;
  margin-right: 5px;
}
.artikl-pregled .znak.usluga {
  background: #ffb300;
  color: rgba(0, 0, 0, 0.87);
}
.artikl-pregled .znak.neaktivan {
  background: #c62828;
}

/* traka s kljucnim brojkama */
.artikl-pregled .brojke {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 22px;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  padding: 8px 16px;
  margin-bottom: 12px;
}
.artikl-pregled .brojke .stavka span {
  display: block;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
  line-height: 1.2;
}
.artikl-pregled .brojke .stavka b {
  font-size: 19px;
  font-variant-numeric: tabular-nums;
}
.artikl-pregled .brojke .stavka b.glavno {
  font-size: 22px;
  color: #1565c0;
}
.artikl-pregled .brojke .crta {
  width: 1px;
  align-self: stretch;
  background: rgba(0, 0, 0, 0.12);
}

/* kartice */
.artikl-pregled .naslov-kartice {
  font-size: 17px;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: #1565c0;
  background: #eef4fb;
  border-bottom: 2px solid #1976d2;
  padding: 8px 16px;
  min-height: 0;
  gap: 8px;
}
.artikl-pregled .naslov-kartice .dodatak {
  font-size: 12px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.6);
}
.artikl-pregled .naslov-kartice.sklopiva {
  cursor: pointer;
}
.artikl-pregled .tijelo {
  padding: 10px 16px 14px;
  color: rgba(0, 0, 0, 0.87);
}

/* red "naziv - vrijednost" */
.artikl-pregled .polja {
  display: grid;
  grid-template-columns: 170px 1fr;
  row-gap: 7px;
  column-gap: 10px;
}
.artikl-pregled .polja .naziv {
  color: rgba(0, 0, 0, 0.6);
  font-size: 14px;
}
.artikl-pregled .polja .vrijednost {
  font-weight: 500;
}
.artikl-pregled .polja .vrijednost.oznake {
  font-weight: 400;
  color: rgba(0, 0, 0, 0.6);
}
.artikl-pregled .uz-vrijednost {
  font-weight: 400;
  color: rgba(0, 0, 0, 0.6);
  margin-left: 4px;
}
.artikl-pregled .prazno {
  color: #cfd8dc;
  font-weight: 400;
}

/* obracun cijene */
.artikl-pregled .obracun {
  width: 100%;
  border-collapse: collapse;
  font-variant-numeric: tabular-nums;
}
.artikl-pregled .obracun td {
  padding: 5px 0;
  border-bottom: 1px solid #f0f0f0;
}
.artikl-pregled .obracun td:last-child {
  text-align: right;
  font-weight: 500;
  /* "100,04 %" se inace lomilo u dva reda */
  white-space: nowrap;
  padding-left: 12px;
}
.artikl-pregled .obracun td.tekstualno {
  white-space: normal;
  font-weight: 400;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.6);
}
.artikl-pregled .obracun tr.zbroj td {
  border-top: 2px solid rgba(0, 0, 0, 0.12);
  border-bottom: none;
  font-weight: 700;
  font-size: 17px;
  padding-top: 8px;
}
.artikl-pregled .obracun tr.zbroj td:last-child {
  color: #1565c0;
}
.artikl-pregled .obracun .sitno {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
  margin-left: 4px;
}

/* slike */
.artikl-pregled .sitno-prazno {
  font-size: 13px;
  line-height: 1;
}
.artikl-pregled .slicice {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}
.artikl-pregled .slicica-okvir {
  position: relative;
}
.artikl-pregled .slicica {
  width: 64px;
  height: 64px;
  object-fit: cover;
  display: block;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  cursor: zoom-in;
}
.artikl-pregled .slicica-nema {
  width: 64px;
  height: 64px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 4px;
}
.artikl-pregled .zvjezdica {
  position: absolute;
  top: -6px;
  right: -6px;
  background: #1976d2;
  color: #fff;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
}
</style>
